(function ($) {

    $(function () {
        toggleTravelerFields();
        toggleDeliveryOptionFields();
        togglePickupOptionFields();
    });

    $('#number_of_travelers').change(function () {
        toggleTravelerFields();
    });

    $('[name=pickup_type]').change(function () {
        togglePickupOptionFields();
    });

    $('[name=delivery_type]').change(function () {
        toggleDeliveryOptionFields();
    });

    $('[name="data[pickup_use_default_address]"]').change(function (e) {
        toggleAddressFields($('.pickup_custom_address_wrap'), e.target.checked);
    });

    $('[name="data[delivery_use_default_address]"]').change(function (e) {
        toggleAddressFields($('.delivery_custom_address_wrap'), e.target.checked);
    });

    $('[name="data[invoice][use_default_address]"]').change(function (e) {
        toggleAddressFields($('.invoice_custom_address_wrap'), e.target.checked);
    });

    $(document).on('click', '.copy_address', function () {
        copyAddress($($(this).data('source')), $($(this).data('target')));
    });

    /**
     * @param source
     * @param target
     */
    function copyAddress(source, target) {

        $(source).find(':input').each(function () {
            let dataName = $(this).data('name');

            if ($(this).attr('type') === 'radio') {
                dataName = $(this).parents('.custom-radio').first().data('name');
            }

            if (dataName) {
                if ($(this).attr('type') === 'radio') {
                    let val = $(this).val();
                    target.find("[name$='[" + dataName + "]'][value='" + val + "']").prop('checked', $(this).is(':checked'));

                } else {
                    if (dataName === 'data[contact][email_confirmation]') {
                        return;
                    }
                    target.find("[data-name='" + dataName + "']").val($(this).val());
                }
            }
        });

    }

    function toggleTravelerFields() {
        $('.extra_traveler_fields').addClass('d-none').find('input').attr({required: false, disabled: true});

        var number = $('#number_of_travelers').val() - 1;
        for (var i = 1; i <= number; i++) {
            $('#traveler_' + i).removeClass('d-none').find('input').prop({required: true, disabled: false});
        }
    }

    function toggleDeliveryOptionFields() {

        let wrapper = $('#delivery-options');

        if ($('[name=delivery_type]').val() === 'vsd') {
            // we will deliver the visa
            // we want to show the product and address fields
            wrapper.removeClass('d-none');

            if (wrapper.find('input[name^="products[delivery]"]').length == 1) {
                // if we only have one product, lets check it
                wrapper.find('input.delivery-products').prop('checked', true);
            }

            if ($('#data_delivery_use_default_address').attr('checked')) {
                // we use the default address.
                // no need to validate
                wrapper.find('input.required').removeAttr('required');
            } else {
                // we dont use the default address.
                // no need to validate
                wrapper.find('input.required').prop('required', true);
            }
        } else {
            // customer will get the visa himself
            // no need to order a delivery product
            wrapper.addClass('d-none').find('input.delivery-products').prop('checked', false);
            // no need to validate
            wrapper.find('input.required').removeAttr('required');
        }
    }

    function togglePickupOptionFields() {

        let wrapper = $('#pickup-options');

        if ($('[name=pickup_type]').val() === 'vsd') {

            // we will pickup the passports
            // we want to show the product and address fields
            wrapper.removeClass('d-none');

            if (wrapper.find('input[name^="products[pickup]"]').length === 1) {
                // if we only have one product, lets check it
                wrapper.find('input.pickup-products').prop('checked', true);
            }

            if ($('#data_pickup_use_default_address').attr('checked')) {
                copyAddress($('.default_address'), $('.pickup_address_wrap'));
                // we use the default address.
                // no need to validate
                wrapper.find('input.required').removeAttr('required');
            } else {
                // we dont use the default address.
                // no need to validate
                wrapper.find('input.required').prop('required', true);
            }
        } else {
            // customer will bring the passport himself
            // no need to order a pickup product
            wrapper.addClass('d-none').find('input.pickup-products').prop('checked', false);
            // no need to validate
            wrapper.find('input.required').removeAttr('required');
        }
    }

    // Show or hide fields based on checked
    function toggleAddressFields(wrapElement, isChecked) {
        if (wrapElement.length) {
            if (isChecked) {
                wrapElement.addClass('d-none');
                wrapElement.find('input.required').attr({required: false, disabled: true});
            }
            else {
                wrapElement.removeClass('d-none');
                wrapElement.find('input.required').attr({required: true, disabled: false});
            }
        }
    }

    //show product description on app step 2
    $(document).on('click', '.show-more', function () {
        let parent = $(this).parent('td');
        let productId = $(this).attr('target');
        parent.find('#more-description-' + productId).show(500);
        parent.find('#show-more-' + productId).hide(0);
        parent.find('#show-less-' + productId).show(0);
        parent.find('#show-more').hide(0);
        parent.find('#show-less').show(0);
        $('#order-items-row').show(500);
        $('#order-items-head').show(500);
    });

    //hide product description on app step 2
    $(document).on('click', '.show-less', function () {
        let parent = $(this).parent('td');
        let productId = $(this).attr('target');
        parent.find('#more-description-' + productId).hide(500);
        parent.find('#show-more-' + productId).show(0);
        parent.find('#show-less-' + productId).hide(0);
        parent.find('#show-more').show(0);
        parent.find('#show-less').hide(0);
        $('#order-items-row').hide(500);
        $('#order-items-head').hide(500);

    });
}(jQuery));
